// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"placeholder-image-m__wrapper__1TfvM","photo-icon":"placeholder-image-m__photo-icon__20HSE"};